import gql from 'graphql-tag';

export const engagementFragment = gql`
  fragment engagementFragment on Engagement {
    favorited
    echoes
    upVotes
    downVotes
    commentCount
  }
`;
